<template>
    <div class='form-control field-date inline-flex align-center'>
        <input  tabindex="0" class="col-auto" placeholder="mês"  type="text" ref="month" @focus="selectAll" :value="month_value" @change="updateMonth" @input="updateMonth"  @blur="monthBlur"  >       
                <span  class=" separator col-auto"> / </span>  
        <input tabindex="0" class="col-auto year" type="text" ref="year" placeholder="ano" @focus="selectAll" :value="year_value" @change="updateYear" @input="updateYear" @blur="yearBlur"  >   
        <div class='append'><slot></slot></div>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

export default {
    
    props:{
        showDay:{
            type:Boolean,
            default:false
        },
        value:{
            default:''
        },
    },
    data(){
        return {
            day_value:'',
            month_value:'',
            year_value:'',
            currentDate:null,
            myValue:'',
        }
    },

    created:function(){
        this.myValue = this.value
        if( ! _.isEmpty(this.myValue)){
            this.init()
        }
    },

   watch:{
        value:function(val){
            this.myValue = val
             if( ! _.isEmpty(this.myValue)){
            this.init()
            }
        }
    },
    

    computed:{
        days:function(){

        },
        months:function(){
            return [
                  { value: "1",  key:"01", text: 'Janeiro' },
                  { value: "2",  key:"02", text: 'Fevereiro' },
                  { value: "3",  key:"03", text: 'Março' },
            ]

        },
        years:function(){

        },
        displayDate:function(){
            return moment(this.currentDate).format("LL")
        },
        
    },
    methods:{

        init:function(){
            let adate = moment(this.myValue)
            if(adate.isValid()){
                this.currentDate = adate;
                this.day_value = adate.get('D')+"";
                this.month_value = adate.get('M')+1+"";
                this.year_value = adate.get('y');
                if(this.day_value.length == 1){ 
                    this.day_value = "0"+this.day_value.toString()
                }
                if(this.month_value.length == 1){ 
                    this.month_value = "0"+this.month_value.toString()
                }
            }
        },
       
        updateDay:function(){
            
            let val = this.$refs.day.value;
            if(val.length == 2){
                this.$refs.month.focus();
            }
            if( val > 31 ){
                val = 31
            }           
            if( val <= 0 ){
                // val = 1
            }           
            this.$refs.day.value = val
            this.day_value = val
            this.updateDate()
            return val;
        },
        dayBlur:function(){
            let val = _.trim(this.$refs.day.value);
            if(val.length == 1){ 
                val = "0"+val.toString()
            }
            this.$refs.day.value = val
            this.day_value = val
             this.updateDate()
        },

        updateMonth:function(){
            let val = this.$refs.month.value;
            if(val.length == 2){
                if(val != this.month_value) //para permitir quando for igual poder voltar para a data
                        this.$refs.year.focus();
            }
            if( val > 12 ){
                val = "12"
            }           
            if( val <= 0 ){
                // val = "01"
            }           
            this.$refs.month.value = val
             this.month_value = val
              this.updateDate()
            return val;
        },
         monthBlur:function(){
            let val = _.trim(this.$refs.month.value);
            if(val.length == 1){ 
                val = "0"+val.toString()
            }
            this.$refs.month.value = val
            this.month_value = val
             this.updateDate()
        },
        updateYear:function(){
            let val = this.$refs.year.value;
            if(val.length == 4){
                this.$refs.year.blur();
            }
            this.year_value = val
            // this.updateDate()
            return val;
        },
        yearBlur:function(){
            let val = _.trim(this.$refs.year.value);
            if(val.length == 1){
                val = "200"+""+val
            }
            if(val.length == 2){
                // if( val < 30 ){
                    val = "20"+""+val
                // }else{
                    // val = "19"+""+val
                // }   
            } 
            this.$refs.year.value = val
            this.year_value = val
            this.updateDate()
        },
        
        updateDate:function(){
            if(this.year_value != '' && this.month_value != ''  ){
                var date = moment(`${this.year_value}-${this.month_value+1}-${this.day_value}`, ["YYYY-MM-DD", "YYYY-M-D","YYYY-MM-D","YYYY-M-DD"]);
                if(date.isValid()){
                    this.currentDate = date
                    this.myValue = date.format("YYYY-MM-DD")
                    this.$emit('change',  this.myValue )
                }
                
            }else{
                this.myValue =  '';
                this.currentDate = null
            }
        },

        selectAll:function(e){
            e.target.select();
        }
    }
}
</script>

<style lang="stylus" scoped>

    .field-date{
        position:relative;
        .append{
            position:absolute;
            right:15px;
        }
        input{
            border:none;
            text-align:center;
            max-width:60px;
            padding:0;
            border-radius:5px;
            &.year{
                max-width:80px;
            }
            &:focus{
                outline:none;
                background:rgba(black,0.2)
            }
        }
        .separator{
            padding:0;
        }

    }

</style>
